import { toDocId, toRefValue } from "./ids";

/**
 * Pure builder for a new action document, matching Android's ActionData wire
 * format so doc.toObject(ActionData) deserializes cleanly into Room. Returns
 * null for an empty/whitespace label (Android disables the add button when the
 * field is empty).
 *
 * IMPORTANT vs. tasks: the primary key field here is `actionId` (not `id`) and
 * the parent link is `taskId` — both numeric Int32 so Room's Int columns can
 * hold them. `id`/`taskId`/`actionOrder` are coerced to numbers; the doc path
 * id (set by the caller) must be String(actionId).
 */
export function buildAction(taskId, label, id, actionOrder, now) {
  const text = (label || "").trim();
  if (!text) return null;

  return {
    actionId: id,
    checkState: false,
    actionLabel: text,
    actionOrder,
    taskId: toRefValue(taskId),
    createdAt: now,
    updatedAt: now,
    remoteState: "remote_state_synced",
    firestoreId: toDocId(id),
  };
}
